import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { CheckType } from '@app/shared/models/models';
import { CommessaService, ISearchNumeroCommessaParams } from '@app/shared/services/commessa.service';

@Component({
    selector: 'mdm-input-numero-commessa-select',
    templateUrl: './input-numero-commessa-select.component.html',
    styleUrl: './input-numero-commessa-select.component.scss',
    standalone: false
})
export class InputNumeroCommessaSelectComponent {

    @Input() options: Array<IS1InputSelectItem>;
    @Input() label: string;
    @Input() control: UntypedFormControl;
    @Input() bindAllObject: boolean = true;
    @Input() readonly: boolean = false;
    @Input() type: CheckType;
  
    @Input() set anno(newValue: number[]) {
      this._anno = newValue;
      this.search();
    }

    @Input() set ente(newValue: string[]) {
      this._ente = newValue;
      this.search();
    }
  
    @Output() onSelectClear = new EventEmitter();
    @Output() onSelectChange = new EventEmitter();
  
    _anno: number[];
    _ente: string[];
    _numero: string;
  
    constructor(private commessaService: CommessaService) { }
    
    ngAfterViewInit(): void {
      this.search();
    }
  
    ngOnInit(): void {}
    
    cleared() {
      this.onSelectClear.emit();
    }
  
    changed(event) {
      this.onSelectChange.emit(event);
    }
  
    setNumeroAndSearch(text?: string) {
      this._numero = text;
      this.search();
    }
  
    search() {
  
      if (this._numero?.length < 3 || this.type == null) {
        this.options = [];
        return;
      }
  
      const params: ISearchNumeroCommessaParams = {
        paging: true,
        page: 1,
        rows: 30,
        ente: this._ente,
        anno: this._anno,
        numero: this._numero
      }
  
      this.commessaService.getNumeri(params, this.type).subscribe(options => {
  
        this.options = options.map(option => {
  
          return {
            code: option.code,
            label: option.label
          } as IS1InputSelectItem
  
        })
  
      })
  
    }

}
